import { render, staticRenderFns } from "./CampaignPointImportModal.vue?vue&type=template&id=4b63cf44&scoped=true&"
import script from "./CampaignPointImportModal.vue?vue&type=script&lang=js&"
export * from "./CampaignPointImportModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPointImportModal.vue?vue&type=style&index=0&id=4b63cf44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63cf44",
  null
  
)

export default component.exports